// s_category IDs considered likely recurring.
// Groups: Animaux (1,5,6,7,11–14), Baby sitting (15–20), Jardinage (27),
//         Cours & Assistance / p_category 6 (34–68, 125–128),
//         Aide ménagère (76,78–82), Soins & bien-être (75)
export const LIKELY_RECURRING_CATEGORIES: number[] = [
  // Animaux
  1, 5, 6, 7, 11, 12, 13, 14,
  // Baby sitting
  15, 16, 17, 18, 19, 20,
  // Jardinage
  27,
  // Cours & Assistance (all sub-categories of p_category 6)
  34, 35, 36, 37, 38, 39, 40, 41, 42, 43,
  44, 45, 46, 47, 48, 49, 50, 51, 52, 53,
  54, 55, 56, 57, 58, 59, 60, 61, 62, 63,
  64, 65, 66, 67, 68, 125, 126, 127, 128,
  // Aide ménagère
  75, 76, 78, 79, 80, 81, 82,
];
